module.exports = __webpack_public_path__ + "static/media/northmelbourne.47dbe1be.svg";